import React, { Component } from 'react'
import StudentsPV from './StudentsPV'
import AuthA from '../../store/actions/AuthA'
import Papa from 'papaparse'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import moment from 'moment'
import find from 'lodash/find'
import {connect} from 'react-redux'

const _ = {
  find, sortBy
}

class StudentsPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: '',
      fields: ['lastName', 'firstName', 'studentNumber', 'actions'],
      activePage: 1,
      itemPerPage: 10,
      selectedIndex: 0,
      column: null,
      direction: null,
      loaded: false,
      results: [],
      modalImportOpen: false,
      schoolYears: [],
      currentSchoolYear: '',
      schoolYearId: '',
      gradeLevel: 'Nursery'
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.getStudents = this.getStudents.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleDataSave = this.handleDataSave.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChangeSchoolYear = this.handleChangeSchoolYear.bind(this);
  }

  getStudents = async (schoolYearId) => {
    console.log("@@@ SY ID: ",schoolYearId)
    await axios.get(`${process.env.REACT_APP_URL}/students?filter[where][schoolYears][like]=${schoolYearId}&filter[where][gradeLevel]=${this.state.gradeLevel}&filter[where][active]=true&filter[order]=lastName%20ASC`)
    .then(response => {
      console.log(response)
      this.setState({ data: response.data, loaded: true });
    })
    .catch(error => {
      console.log(error)
      if (error.response) {
        alert(`${error.response.data.error.message}`);
      } else if (error.request) {
        alert(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        alert('Error. Please contact your administrator for assistance.');
      }
      this.setState({ loaded: false });
    });
  }

  isSearched(searchKey) {
    return function(item) {
      if (item.studentNumber) {
        return (
          !searchKey ||
          item.firstName.toLowerCase().includes(searchKey.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchKey.toLowerCase()) ||
          item.studentNumber.includes(searchKey)
        );
      } else {
        return (
          !searchKey ||
          item.firstName.toLowerCase().includes(searchKey.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchKey.toLowerCase())
        );
      }
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value }, () => this.getStudents(this.state.schoolYearId))
  }

  handlePaginationChange(e, {activePage}){
    this.setState({
      activePage: activePage,
    });
  }

  handleFileChange(file) {
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: this.handleDataChange
    });
  }

  handleDataChange(results) {
    // this.handleDataSave(results.data);
    this.setState({results: results.data})
    console.log('Parsing complete:', results);
  }

  handleRowClick(student) {
    this.props.history.push(this.props.location.pathname+'/' + student.studentId);
  }

  handleChangeSchoolYear = (e, { value }) => {
    this.setState({ schoolYearId: value, loaded: false }, () => {
      setTimeout( async () => {
        this.getStudents(value)
      }, 2000)
    })
  }

  async handleDataSave() {
    // const content = fileReader.result;
    const data = this.state.results;
    let parsedStudent = {}, successCount = 0;

    for (let i = 0; i < data.length; i++) {
      parsedStudent = {
        firstName: data[i]['firstName'],
        middleName: data[i]['middleName'],
        lastName: data[i]['lastName'],
        nickName: data[i]['nickName'],
        gender: data[i]['gender'],
        birthDate: moment(data[i]['birthDate']),
        address: data[i]['address'],
        email: data[i]['email'],
        lrn: data[i]['lrn'],
        studentNumber: data[i]['studentNumber'],
        religion: data[i]['religion'],
        placeOfBirth: data[i]['placeOfBirth'],
        mobile1: data[i]['mobile1'],
        mobile2: data[i]['mobile2'],
        contactPerson: data[i]['contactPerson'],
        contactPersonNumber: data[i]['contactPersonNumber'],
        contactPersonAddress: data[i]['contactPersonAddress'],
        guardianName: data[i]['guardianFirstName'] + " " + data[i]['guardianMiddleName'] + " " + data[i]['guardianLastName'] + " " + data[i]['guardianExtensionName'],
        guardianAddress: data[i]['guardianAddress'],
        guardianOccupation: data[i]['guardianOccupation'],
        guardianOfficeAddress: data[i]['guardianOfficeAddress'],
        guardianNumber: data[i]['guardianNumber'],
        beenHospitalized: data[i]['beenHospitalized'],
        hospitalReason: data[i]['hospitalReason'],
        medicalHistory: data[i]['medicalHistory'],
      };
      const url = process.env.REACT_APP_URL+'/students';
      try {
        await axios.request({
          method: 'post',
          url: url,
          data: parsedStudent
        })
        console.log(`Successfully loaded:${i+1}`);
        successCount++;
      } catch(error){

        console.log(error)
        if (error.response) {
          alert(`Line ${i+2}: ${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.setState({modalImportOpen: false}, this.getStudents(this.state.schoolYearId))
        break;
      }
    }
    alert(`${successCount} student/s successfully uploaded.`)
    this.setState({modalImportOpen: false}, this.getStudents(this.state.schoolYearId))
  }

  handleSubmit(data) {
    const url = process.env.REACT_APP_URL+'/students';
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {
        alert(`Successfully added a student.`)
        this.getStudents(this.state.schoolYearId)
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.getStudents(this.state.schoolYearId)
      });
  }

  handleUpdate(data,id) {
    const url = process.env.REACT_APP_URL+'/students/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        alert(`Successfully updated a student.`)
        this.getStudents(this.state.schoolYearId)
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.getStudents(this.state.schoolYearId)
      });
  }

  handleDelete(id) {
    const url = process.env.REACT_APP_URL+'/students/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false}
      })
      .then(response => {this.getStudents(this.state.schoolYearId)})
      .catch(err => console.log(err));
  }

  handleModalImportOpen = (open) => {
    this.setState({modalImportOpen: open})
  }

  getSchoolYears = () => {
    axios.get(process.env.REACT_APP_URL+'/schoolyears?filter[where][active]=true')
    .then(response => {
      const currentSchoolYear = _.find(response.data, {
        isCurrent: true
      });

      this.setState({
        schoolYears: response.data,
        schoolYearId: currentSchoolYear.schoolYearId,
        currentSchoolYear: currentSchoolYear,
      }, () => {
        console.log(currentSchoolYear)
        this.getStudents(currentSchoolYear.schoolYearId);
      })
    })

  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Students'});
    this.getSchoolYears();
  }

  render() {
    return (
      <StudentsPV
        auth={this.props.auth}
        userType={this.props.userType}
        activePage={this.state.activePage}
        itemPerPage={this.state.itemPerPage}
        column={this.state.column}
        direction={this.state.direction}
        data={this.state.data}
        searchKey={this.state.searchKey}
        fields={this.state.fields}
        loaded={this.state.loaded}
        schoolYears={this.state.schoolYears}
        schoolYearId={this.state.schoolYearId}
        currentSchoolYear={this.state.currentSchoolYear}
        modalImportOpen={this.state.modalImportOpen}
        gradeLevel={this.state.gradeLevel}
        handleModalImportOpen={this.handleModalImportOpen}
        isSearched={this.isSearched}
        onSearchChange={this.onSearchChange}
        handleSort={this.handleSort}
        handlePaginationChange={this.handlePaginationChange}
        handleFileChange={this.handleFileChange}
        handleChange={this.handleChange}
        handleDataSave={this.handleDataSave}
        handleRowClick={this.handleRowClick}
        handleSubmit={this.handleSubmit}
        handleUpdate={this.handleUpdate}
        handleDelete={this.handleDelete}
        handleChangeSchoolYear={this.handleChangeSchoolYear}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentsPC);
